var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ah-voucher-status-label",class:{finish: _vm.status === 1}},[(_vm.status === 1)?_c('span',[_vm._v("已核准")]):_vm._e(),(_vm.status === 0)?_c('span',[_vm._v("待辦")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }